module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Camera_16"],"path":[{"$":{"d":"M11,3H5L6,1h4ZM8,7a2,2,0,1,0,2,2A2,2,0,0,0,8,7Zm8-3V14H0V4ZM11.5,9A3.5,3.5,0,1,0,8,12.5,3.5,3.5,0,0,0,11.5,9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Camera_16.svg
// module id = gd+5
// module chunks = 1